import "./header.css";
import React, {useEffect, useState} from 'react';
import paths from "../../paths";
import {Link, useLocation, useNavigate} from "react-router-dom";
import logo from "../../assets/img/logo.png"
import {auth, authSubject} from "../../store/auth.store";
import {copyMemberNumber, CurrencyFormat, isLuckyGamesActive, useForceUpdate} from "../../services/misc.functions";
import {isMobile} from "../../App";
import authUserIcon from "../../assets/icons/home/user.png";
import authUserPlusIcon from "../../assets/icons/home/user-plus.png";
import {userLogout} from "../../services/auth.service";
import {gamePlayerSubject} from "../../pages/games/games";
import iconBack from "../../assets/feather/chevron-left.svg";


function UserMenu() {

    useEffect(() => {
        var logoutButton = document.getElementById('logoutButton');
        logoutButton?.addEventListener('click', () => {
            userLogout();
        });
    }, []);

    useEffect(() => {
        var navItems: any = document.getElementsByClassName('user-menu-links');
        for (const navItem of navItems) {

            navItem.addEventListener('click', (e: any) => {
                try {
                    // @ts-ignore
                    dataLayer.push({
                        event: "accMenu_click",
                        button_name: e.target.innerHTML
                    });
                } catch (e) {

                }
            })
        }

    }, []);

    return <>
        <div className="user-menu-layout">
        </div>
        <div className="user-menu">
            <div className={"w-100"}>
                <div className="menu-balance-left">
                    <p className="text-xsmall text-bold">TL Bakiye</p>
                    <p className="text-small text-primary text-bolder pt-1">{auth.member.balance_debit}₺</p>
                </div>
                <ul className={"ps-0"}>
                    <p className="text-xsmall text-gray regular mb-3 ms-3">BANKA İŞLEMLERİ</p>
                    <li>
                        <a className="user-menu-links"
                           href={paths.deposit.url}>
                            <button className="button tertiary filled">
                                <div className="user-menu-button-wrapper">
                                    <div className="me-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                             height="24" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M17.9999 6L5.99994 18M5.99994 18H13.9999M5.99994 18V10"
                                                stroke="#1F3735" strokeWidth="2.76667"
                                                strokeLinecap="round"
                                                strokeLinejoin="round">
                                            </path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-small text-primary medium  user-menu-title">Para Yatır</p>
                                        <p className="text-xsmall text-gray user-menu-desc">7/24 Tüm Bankalar</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </li>
                    <li>
                        <a className="user-menu-links"
                           href={paths.withdraw.url}>
                            <button className="button xs tertiary filled ">
                                <div className="user-menu-button-wrapper">
                                    <div className="me-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                             height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M6 18L18 6M18 6H10M18 6V14"
                                                  stroke="#1F3735"
                                                  strokeWidth="3.32" strokeLinecap="round"
                                                  strokeLinejoin="round">
                                            </path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-small text-primary  user-menu-title">Para Çek</p>
                                        <p className="text-xsmall text-gray user-menu-desc">Para Çekme Limiti
                                            Yoktur</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </li>
                    <li>
                        <a className="user-menu-links"
                           href={paths.memberBankAccounts.url}>
                            <button className="button xs tertiary filled ">
                                <div className="user-menu-button-wrapper">
                                    <div className="me-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20"
                                             height="20" viewBox="0 0 20 20" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M9.85443 1.69338C9.95131 1.68489 10.0487 1.68489 10.1456 1.69338C10.2571 1.70316 10.3633 1.72693 10.4477 1.74581L16.6589 3.12611C16.8259 3.1632 16.992 3.20007 17.1323 3.24226C17.289 3.28935 17.4672 3.35776 17.6409 3.48288C17.8862 3.65959 18.0788 3.8997 18.1981 4.17748C18.2826 4.37417 18.3107 4.56304 18.3227 4.72618C18.3334 4.87235 18.3334 5.04242 18.3334 5.2135V6.19338C18.3334 6.40363 18.3334 6.60846 18.3192 6.78187C18.3037 6.97237 18.267 7.19715 18.1517 7.42333C17.9919 7.73694 17.7369 7.99191 17.4233 8.15169C17.1972 8.26694 16.9724 8.30366 16.7819 8.31923C16.7448 8.32226 16.7063 8.32464 16.6667 8.32651V13.3402C16.7063 13.3421 16.7448 13.3444 16.7819 13.3475C16.9724 13.363 17.1972 13.3997 17.4233 13.515C17.7369 13.6748 17.9919 13.9298 18.1517 14.2434C18.267 14.4695 18.3037 14.6943 18.3192 14.8848C18.3334 15.0582 18.3334 15.2631 18.3334 15.4733V16.1934C18.3334 16.4037 18.3334 16.6085 18.3192 16.7819C18.3037 16.9724 18.267 17.1971 18.1517 17.4233C17.9919 17.7369 17.7369 17.9919 17.4233 18.1517C17.1972 18.2669 16.9724 18.3037 16.7819 18.3192C16.6084 18.3334 16.4036 18.3334 16.1933 18.3333H3.80678C3.59646 18.3334 3.39163 18.3334 3.21817 18.3192C3.02767 18.3037 2.80289 18.2669 2.57671 18.1517C2.2631 17.9919 2.00814 17.7369 1.84835 17.4233C1.7331 17.1971 1.69638 16.9724 1.68081 16.7819C1.66664 16.6084 1.66666 16.4036 1.66669 16.1932L1.66669 15.4734C1.66666 15.2631 1.66664 15.0583 1.68081 14.8848C1.69638 14.6943 1.7331 14.4695 1.84835 14.2434C2.00814 13.9298 2.2631 13.6748 2.57671 13.515C2.80289 13.3997 3.02767 13.363 3.21817 13.3475C3.25522 13.3444 3.2937 13.3421 3.33335 13.3402V8.3265C3.2937 8.32464 3.25522 8.32226 3.21817 8.31923C3.02767 8.30366 2.80289 8.26694 2.57671 8.15169C2.2631 7.9919 2.00814 7.73694 1.84835 7.42333C1.7331 7.19715 1.69638 6.97237 1.68081 6.78187C1.66664 6.60841 1.66666 6.40358 1.66669 6.19326L1.66669 5.21349C1.66667 5.04241 1.66665 4.87235 1.67738 4.72618C1.68936 4.56304 1.71747 4.37417 1.80194 4.17748C1.92124 3.8997 2.11384 3.65959 2.35913 3.48288C2.53281 3.35776 2.71109 3.28934 2.86774 3.24226C3.0081 3.20007 3.17412 3.1632 3.34113 3.12611L9.55237 1.74581C9.63673 1.72693 9.74299 1.70316 9.85443 1.69338ZM5.00002 8.33335V13.3333H7.08335V8.33335H5.00002ZM8.75002 8.33335V13.3333H11.25V8.33335H8.75002ZM12.9167 8.33335V13.3333H15V8.33335H12.9167Z"
                                                  fill="#1F3735">
                                            </path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-small text-primary user-menu-title">Banka Hesaplarım</p>
                                        <p className="text-xsmall text-gray user-menu-desc">Hesap Ekle ve Gör</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </li>
                    <li>

                        <a className="user-menu-links"
                           href={paths.memberTransactions.url}>
                            <button className="button xs tertiary filled ">
                                <div className="user-menu-button-wrapper">
                                    <div className="me-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                             viewBox="0 0 16 16"
                                             fill="none">
                                            <path
                                                d="M13.3334 11.3333H2.66675M2.66675 11.3333L5.33341 8.66667M2.66675 11.3333L5.33341 14M2.66675 4.66667H13.3334M13.3334 4.66667L10.6667 2M13.3334 4.66667L10.6667 7.33333"
                                                stroke="#1F3735" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round">
                                            </path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-small text-primary user-menu-title">Hesap Hareketlerim</p>
                                        <p className="text-xsmall text-gray user-menu-desc">Tüm Hesap İşlemlerim</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </li>
                </ul>
            </div>
            <div className={"w-100"}>
                <div className="menu-balance-right">
                    <p className="text-xsmall text-bold">Puan Bakiye</p>
                    <p className="text-small text-primary text-bolder pt-1">{auth.member.balance_point}₺</p>
                </div>
                <ul className={"ps-0"}>
                    <p className="text-xsmall text-gray me-3">AYARLAR </p>
                    <div style={{height: "16px"}}>
                    </div>
                    <li>
                        <a className="user-menu-links"
                           href={paths.memberInfo.url}>
                            <button className="button xs tertiary filled ">
                                <div className="user-menu-button-wrapper">
                                    <div className="me-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                             height="16" viewBox="0 0 20 20" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M2.84845 15.2526C4.49259 13.0766 7.0824 11.6667 10 11.6667C12.9176 11.6667 15.5074 13.0766 17.1515 15.2526C17.159 15.2624 17.1664 15.2723 17.1739 15.2822C17.3153 15.4691 17.4669 15.6696 17.5752 15.863C17.7063 16.097 17.8035 16.3678 17.7975 16.6971C17.7926 16.9618 17.7124 17.2097 17.615 17.4053C17.5176 17.601 17.3683 17.8144 17.16 17.9778C16.8822 18.1958 16.5798 18.273 16.3111 18.3052C16.0754 18.3334 15.7961 18.3334 15.5153 18.3333C15.5026 18.3333 15.49 18.3333 15.4773 18.3333H4.52269C4.51004 18.3333 4.49738 18.3333 4.48473 18.3333C4.20389 18.3334 3.92457 18.3334 3.68887 18.3052C3.42021 18.273 3.11779 18.1958 2.84002 17.9778C2.63173 17.8144 2.48237 17.601 2.38498 17.4053C2.28758 17.2097 2.20738 16.9618 2.20254 16.6971C2.19651 16.3678 2.29369 16.097 2.4248 15.863C2.53312 15.6696 2.6847 15.4691 2.82606 15.2822C2.83356 15.2723 2.84102 15.2624 2.84845 15.2526Z"
                                                  fill="#1F3735">
                                            </path>
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M5.41667 6.24999C5.41667 3.71868 7.46869 1.66666 10 1.66666C12.5313 1.66666 14.5833 3.71868 14.5833 6.24999C14.5833 8.78129 12.5313 10.8333 10 10.8333C7.46869 10.8333 5.41667 8.78129 5.41667 6.24999Z"
                                                  fill="#1F3735">
                                            </path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-small text-primary user-menu-title">Profil
                                            Ayarları</p>
                                        <p className="text-xsmall text-gray user-menu-desc">E-mail, Telefon, Şifre</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </li>
                    <li>
                        <a className="user-menu-links"
                           href={paths.notificationInfo.url}>
                            <button className="button xs tertiary filled  ">
                                <div className="user-menu-button-wrapper">
                                    <div className="me-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20"
                                             height="20" viewBox="0 0 20 20" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M7.26612 4.76791C7.14802 4.4509 7.08335 4.10783 7.08335 3.75001C7.08335 2.13918 8.38919 0.833344 10 0.833344C11.6109 0.833344 12.9167 2.13918 12.9167 3.75001C12.9167 4.10783 12.852 4.4509 12.7339 4.7679C13.2222 4.99689 13.6767 5.28882 14.0813 5.63947C15.1852 6.59616 15.8334 7.92144 15.8334 9.33334C15.8334 11.0897 16.2669 12.3333 16.7773 13.1964L16.7858 13.2109C17.1139 13.7657 17.3703 14.1993 17.5422 14.5104C17.6281 14.666 17.7037 14.8101 17.7587 14.9336C17.7859 14.9948 17.816 15.0683 17.8394 15.1463C17.8569 15.2045 17.8999 15.3554 17.882 15.5383C17.8722 15.6387 17.8497 15.8381 17.7336 16.0417C17.6175 16.2452 17.4573 16.3661 17.3758 16.4256C17.2431 16.5227 17.1103 16.5643 17.0442 16.5826C16.9662 16.6042 16.8903 16.617 16.8274 16.6254C16.7017 16.6422 16.5553 16.6508 16.4027 16.6561C16.0985 16.6667 15.6732 16.6667 15.1372 16.6667H13.2283C12.8583 18.1044 11.5532 19.1667 10 19.1667C8.44682 19.1667 7.14174 18.1044 6.7717 16.6667H4.86294C4.327 16.6667 3.90156 16.6667 3.59736 16.6561C3.44477 16.6508 3.29837 16.6422 3.17264 16.6254C3.10975 16.617 3.03391 16.6042 2.95586 16.5826C2.88972 16.5643 2.75693 16.5227 2.62422 16.4256C2.54279 16.3661 2.3826 16.2452 2.26648 16.0417C2.15037 15.8381 2.12785 15.6387 2.11804 15.5383C2.10016 15.3554 2.14315 15.2045 2.16062 15.1463C2.18405 15.0683 2.21412 14.9948 2.24138 14.9336C2.29635 14.8101 2.37196 14.666 2.45789 14.5104C2.62979 14.1993 2.88609 13.7658 3.21424 13.2108L3.22277 13.1964C3.73315 12.3333 4.1667 11.0897 4.1667 9.33334C4.1667 7.92144 4.81486 6.59615 5.91872 5.63947C6.32331 5.28883 6.77787 4.99689 7.26612 4.76791ZM8.75002 3.75001C8.75002 3.05965 9.30966 2.50001 10 2.50001C10.6904 2.50001 11.25 3.05965 11.25 3.75001C11.25 3.93425 11.2105 4.10874 11.1392 4.26594C10.7657 4.20023 10.3842 4.16668 10 4.16668C9.61581 4.16668 9.2343 4.20023 8.86089 4.26594C8.78955 4.10874 8.75002 3.93425 8.75002 3.75001ZM10 17.5C10.6169 17.5 11.1555 17.1648 11.4437 16.6667H8.55632C8.8445 17.1648 9.38312 17.5 10 17.5Z"
                                                  fill="#1F3735">
                                            </path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-small text-primary user-menu-title">İletişim
                                            Ayarları</p>
                                        <p className="text-xsmall text-gray user-menu-desc">E-posta,
                                            SMS, Müşteri
                                            Hizmetleri</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </li>
                    <li>
                        <a className="user-menu-links" href={paths.supportFAQ.url}>
                            <button className="button xs tertiary filled  ">
                                <div className="user-menu-button-wrapper">
                                    <div className="me-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20"
                                             height="20" viewBox="0 0 20 20" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M10 0.833252C4.93743 0.833252 0.833374 4.93731 0.833374 9.99992C0.833374 15.0625 4.93743 19.1666 10 19.1666C15.0626 19.1666 19.1667 15.0625 19.1667 9.99992C19.1667 4.93731 15.0626 0.833252 10 0.833252ZM9.0889 6.89261C9.42823 6.69318 9.8272 6.62028 10.2151 6.68682C10.6031 6.75336 10.9549 6.95505 11.2084 7.25616C11.4619 7.55727 11.6006 7.93838 11.6 8.33198L11.6 8.33322C11.6 8.72416 11.2958 9.13173 10.7211 9.51484C10.4591 9.68949 10.1912 9.82404 9.98555 9.91546C9.88388 9.96064 9.80032 9.99401 9.74413 10.0154C9.71919 10.0249 9.69415 10.0341 9.66897 10.0429C9.23291 10.1888 8.99736 10.6604 9.1428 11.0967C9.28834 11.5334 9.76027 11.7693 10.1969 11.6238L10.3375 11.5729C10.418 11.5422 10.5297 11.4975 10.6624 11.4385C10.9255 11.3216 11.2826 11.1436 11.6456 10.9016C12.3208 10.4515 13.2663 9.60927 13.2667 8.33398C13.2678 7.54695 12.9903 6.78493 12.4835 6.18283C11.9765 5.5806 11.2728 5.17722 10.4969 5.04414C9.72103 4.91106 8.9231 5.05686 8.24443 5.45572C7.56576 5.85458 7.05015 6.48076 6.78892 7.22335C6.6362 7.65751 6.86434 8.13327 7.2985 8.286C7.73266 8.43872 8.20842 8.21058 8.36115 7.77642C8.49176 7.40513 8.74957 7.09204 9.0889 6.89261ZM10 13.3332C9.5398 13.3332 9.1667 13.7063 9.1667 14.1666C9.1667 14.6268 9.5398 14.9999 10 14.9999H10.0084C10.4686 14.9999 10.8417 14.6268 10.8417 14.1666C10.8417 13.7063 10.4686 13.3332 10.0084 13.3332H10Z"
                                                  fill="#1F3735">
                                            </path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-small text-primary user-menu-title">Sıkça Sorulan Sorular</p>
                                        <p className="text-xsmall text-gray user-menu-desc">Detaylı Tüm Sorular</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </li>
                    <li>
                        <a className="user-menu-links" href="javascript:void(0)" id={"logoutButton"}>
                            <button className="button xs tertiary filled">
                                <div className="user-menu-button-wrapper">
                                    <div className="me-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                             viewBox="0 0 16 16"
                                             fill="none">
                                            <path
                                                d="M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6M6 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H6"
                                                stroke="#1F3735" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round">
                                            </path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-small text-primary user-menu-title">Çıkış Yap</p>
                                        <p className="text-xsmall text-gray user-menu-desc">Günvenli Çıkış yap</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </>
}


export function Header() {
    const forceUpdate = useForceUpdate();
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false)
    const [openMore, setOpenMore] = useState(false)
    const [gameTitle, setGameTitle] = useState<string | null>(null)
    const isGamePlayer = isMobile && pathname.startsWith(`${paths.games.url}/`);

    useEffect(() => {
        const subscription = gamePlayerSubject.subscribe(setGameTitle);
        return () => subscription.unsubscribe();
    }, [])

    useEffect(() => {
        let auth_subscriber = authSubject.subscribe((res: any) => {
            forceUpdate();
        })
        return () => {
            auth_subscriber.unsubscribe();
        }
    }, [])

    useEffect(() => {
        forceUpdate();
        setShowMenu(false);
    }, [pathname]);


    const handleClickOutside = (event: any) => {
        let ref: any = document.getElementById('member-dropdown-menu')
        if (ref?.contains(event.target) === true) {
        } else {
            if (event.target.id !== 'menu') {
                setShowMenu(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    useEffect(() => {
        var navItems: any = document.getElementsByClassName('navItem');
        for (const navItem of navItems) {
            navItem.addEventListener('click', (e: any) => {
                try {
                    // @ts-ignore
                    dataLayer.push({
                        event: "menu_click",
                        button_name: e.target.innerHTML
                    });
                } catch (e) {

                }
            })
        }

    }, []);

    if ((pathname.includes(paths.betting.url) || pathname.includes(paths.bettingFob.url) || pathname.includes(paths.bettingLongterm.url)) && isMobile) {
        return <></>
    }


    return (
        <header>
            <div className={"container"}>
                <div className={"d-flex align-items-center justify-content-between"}>
                    {isGamePlayer ? (
                        <div className={"header-game"}>
                            <img className={"header-game-back"} src={iconBack} alt={"geri"}
                                 onClick={() => navigate(paths.games.url)}/>
                            <span className={"header-game-title"}>{gameTitle}</span>
                        </div>
                    ) : (
                        <div className={"logo"}>
                            <Link to={paths.home.url}>
                                <img className="nav-logo" alt="EKURI"
                                     src={logo}/>
                            </Link>
                        </div>
                    )}
                    <div className={"header-navigation-menu"}>
                        <nav className="mx-auto">

                            <Link to={paths.betting.url} className={"navItem " + paths.betting.url.replace('/', '')}>Bahis
                                Yap</Link>
                            <Link to={paths.bettingFob.url}
                                  className={"navItem " + paths.bettingFob.url.replace('/', '')}>Sabit İhtimalli
                                Bahis</Link>
                            {isLuckyGamesActive() &&
                                <Link style={{position:"relative"}} to={paths.games.url}
                                      className={"navItem " + paths.games.url.replace('/', '')}>
                                    Bas Kazan
                                    <div style={{
                                        position:"absolute",
                                        top:"0px",
                                        right:"0px",
                                        backgroundColor:"red",
                                        color:"white",
                                        padding:"2px 5px",
                                        fontSize:"10px",
                                        fontWeight:"bold"
                                    }}>Yeni</div>
                                </Link>}
                            <Link to={paths.bettingLongterm.url}
                                  className={"navItem " + paths.bettingLongterm.url.replace('/', '')}>Uzun Vadeli
                                Bahis</Link>

                            <Link to={paths.memberTickets.url}
                                  className={"navItem " + paths.memberTickets.url.replace('/', '')}>Kuponlarım</Link>
                            <Link to={paths.results.url}
                                  className={"navItem " + paths.results.url.replace('/', '')}>Sonuçlar</Link>
                            <Link to={paths.stream.url}
                                  className={"navItem " + paths.stream.url.replace('/', '')}>CANLI TV</Link>

                            <Link to={paths.tipsterComments.url}
                                  className={"navItem " + paths.tipsterComments.url.replace('/', '')}>Yazar
                                Yorumları</Link>
                            <Link to={paths.campaigns.url}
                                  className={"navItem " + paths.campaigns.url.replace('/', '')}>Kampanyalar</Link>
                            <div className="position-relative">
                                <div className={`header-more ${openMore ? 'isOpen' : ''}`} onClick={() => {
                                    setOpenMore((prevOpenMore) => !prevOpenMore);

                                }}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 6L8 10L12 6" stroke="#ffffff" strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round">
                                        </path>
                                    </svg>
                                </div>
                                {openMore && <div className="navigation-menu">
                                    <div className="navigation-menu-item">
                                        <a title="PROGRAM"
                                           className="header-link"
                                           onClick={() => {
                                               setOpenMore(false)
                                           }}
                                           href={paths.program.url}>Program</a>
                                    </div>
                                    <div className="navigation-menu-item">
                                        <a title="HAZIR KUPONLAR"
                                           className="header-link"
                                           onClick={() => {
                                               setOpenMore(false)
                                           }}
                                           href={paths.tipsterCoupons.url}>Hazır Kuponlar</a>
                                    </div>
                                    <div className="navigation-menu-item">
                                        <a title="MUHTEMELLER"
                                           className="header-link"
                                           onClick={() => {
                                               setOpenMore(false)
                                           }}
                                           href={paths.possibles.url}>Muhtemeller</a>
                                    </div>
                                    <div className="navigation-menu-item">
                                        <a title="AGF"
                                           className="header-link"
                                           onClick={() => {
                                               setOpenMore(false)
                                           }}
                                           href={paths.agf.url}>AGF</a>
                                    </div>
                                    <div className="navigation-menu-item">
                                        <a title="HAKKIMIZDA"
                                           onClick={() => {
                                               setOpenMore(false)
                                           }}
                                           className="header-link"
                                           href={`${paths.flatpage.url}/hakkimizda`}>Hakkımızda</a>
                                    </div>
                                </div>}
                            </div>
                        </nav>
                    </div>

                    {
                        auth.authentication && auth.member && auth.member.id ?
                            <div className={"header-profile-wrapper"}>
                                <div className={"header-profile me-2"}>
                                    <div className="d-flex justify-content-end">
                                        <div className="d-flex justify-content-end">
                                            <div className="Header_userInfo__iU_hk">
                                                <div className={"position-relative"} onClick={() => {
                                                    copyMemberNumber(auth.member.id, 'Üye numaranız kopyalandı!');
                                                }}>
                                                    <div className={"position-relative"}>
                                                        <div className="d-flex justify-content-end">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="13"
                                                                 height="16"
                                                                 viewBox="0 0 13 16" fill="none">
                                                                <path
                                                                    d="M11.4637 0.830841H5.31871C4.91127 0.830841 4.52052 0.992696 4.23242 1.2808C3.94432 1.5689 3.78246 1.95965 3.78246 2.36709V3.39126H2.24621C1.83877 3.39126 1.44802 3.55311 1.15992 3.84121C0.871815 4.12932 0.709961 4.52007 0.709961 4.92751V13.6329C0.709961 14.0404 0.871815 14.4311 1.15992 14.7192C1.44802 15.0073 1.83877 15.1692 2.24621 15.1692H8.39121C8.79865 15.1692 9.1894 15.0073 9.4775 14.7192C9.76561 14.4311 9.92746 14.0404 9.92746 13.6329V12.6088H11.4637C11.8712 12.6088 12.2619 12.4469 12.55 12.1588C12.8381 11.8707 13 11.4799 13 11.0725V2.36709C13 1.95965 12.8381 1.5689 12.55 1.2808C12.2619 0.992696 11.8712 0.830841 11.4637 0.830841ZM8.90329 13.6329C8.90329 13.7687 8.84934 13.899 8.75331 13.995C8.65728 14.0911 8.52702 14.145 8.39121 14.145H2.24621C2.1104 14.145 1.98015 14.0911 1.88411 13.995C1.78808 13.899 1.73413 13.7687 1.73413 13.6329V4.92751C1.73413 4.79169 1.78808 4.66144 1.88411 4.56541C1.98015 4.46938 2.1104 4.41542 2.24621 4.41542H8.39121C8.52702 4.41542 8.65728 4.46938 8.75331 4.56541C8.84934 4.66144 8.90329 4.79169 8.90329 4.92751V13.6329ZM11.9758 11.0725C11.9758 11.2083 11.9218 11.3386 11.8258 11.4346C11.7298 11.5306 11.5995 11.5846 11.4637 11.5846H9.92746V4.92751C9.92746 4.52007 9.76561 4.12932 9.4775 3.84121C9.1894 3.55311 8.79865 3.39126 8.39121 3.39126H4.80663V2.36709C4.80663 2.23128 4.86058 2.10103 4.95661 2.00499C5.05265 1.90896 5.1829 1.85501 5.31871 1.85501H11.4637C11.5995 1.85501 11.7298 1.90896 11.8258 2.00499C11.9218 2.10103 11.9758 2.23128 11.9758 2.36709V11.0725Z"
                                                                    fill="white">
                                                                </path>
                                                            </svg>
                                                            <p className="text-small text-white text-bold ms-1 me-1 ps-1 lh-1">{auth.member.id}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end">
                                                    <p className="text-xsmall text-white pe-1 pt-1">Bakiye: {CurrencyFormat(Number(auth.member.balance_debit) + Number(auth.member.balance_point))}₺</p>
                                                </div>
                                            </div>
                                        </div>
                                        {!isMobile && <div className="user-more" onClick={() => {
                                            if (isMobile) {
                                            } else {
                                                setShowMenu((prevShowMenu) => !prevShowMenu);
                                            }

                                        }}>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 6L8 10L12 6" stroke="white" strokeWidth="1.5"
                                                      strokeLinecap="round" strokeLinejoin="round">
                                                </path>
                                            </svg>
                                        </div>}
                                    </div>
                                </div>
                                {showMenu && <UserMenu/>}
                            </div> :
                            <div className={"auth-btn-wrapper"}>
                                <button onClick={() => {
                                    navigate(paths.login.url);
                                }} className="button xs primary filled header-login-btn ">
                                    {isMobile && <img className="header-auth-icon" src={authUserIcon} alt=""/>}
                                    <p className="text-xsmall text-white text-bold">{isMobile ? "GİRİŞ" : "GİRİŞ YAP"}</p>
                                </button>
                                <button onClick={() => {
                                    navigate(paths.register.url);
                                }} className="button xs secondary filled header-sign-up-btn">
                                    {isMobile && <img className="header-auth-icon" src={authUserPlusIcon} alt=""/>}
                                    <p className="text-xsmall text-bolder">ÜYE OL</p>
                                </button>
                            </div>
                    }
                </div>
            </div>
        </header>
    );
}


export function Breadcrumbs() {
    const {pathname} = useLocation();
    if ((pathname.includes(paths.betting.url) || pathname.includes(paths.bettingFob.url) || pathname.includes(paths.bettingLongterm.url)) && isMobile) {
        return <></>
    }

    return <div className="breadcrumb-wrapper">
        {/*   <div className={"container"}>
            {!isMobile && <div className="breadcrumb-list">
                <a className="breadcrumb-list-item"
                   href="/">Anasayfa</a>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M4.5 9L7.5 6L4.5 3" stroke="white" strokeOpacity="0.5" strokeWidth="1.33"
                          strokeLinecap="round" strokeLinejoin="round">
                    </path>
                </svg>
                <a className="breadcrumb-list-item is-active" href={path.root}>
                    {path.breadcrumbTitle}
                </a>
            </div>}
        </div>*/}

    </div>


}
